import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const isDashboard = location.pathname === '/' || location.pathname === '/dashboard';

  // Les dialogues et menus shadcn se rendent dans un portail hors de ce composant :
  // le thème est donc posé sur la racine du document, le temps que le Layout est affiché.
  useEffect(() => {
    document.documentElement.classList.add('kit-theme');
    return () => document.documentElement.classList.remove('kit-theme');
  }, []);

  return (
    <div className="kit-surface h-screen overflow-hidden">
      {/* Retour simple au dashboard depuis les autres pages */}
      {!isDashboard && (
        <button
          type="button"
          onClick={() => navigate('/dashboard')}
          className="kit-glass kit-press fixed top-4 left-4 z-40 flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold text-[#e8eef2] cursor-pointer"
        >
          <ArrowLeft className="w-4 h-4" />
          Dashboard
        </button>
      )}

      <div className={`h-full overflow-auto ${isDashboard ? '' : 'pt-14'}`}>{children}</div>
    </div>
  );
}
